import * as ApplicantActions from './applicant';
import * as AuthActions from './auth';
import * as ComboAction from './combo';
import * as LoadActions from './loading';
import * as NavigationActions from './navigation';
import * as VacancyActions from './vacancy';
import * as ModalActions from './modal';
import * as UserActions from './user';
import { routerActions } from 'react-router-redux';


export const ActionCreators = Object.assign({},
    ApplicantActions,
    AuthActions,
    ComboAction,
    LoadActions,
    NavigationActions,
    routerActions,
    VacancyActions,
    ModalActions,
    UserActions
);


// WEBPACK FOOTER //
// ./src/actions/index.js